import { giphyDarkestGrey } from '@giphy/colors'
import styled from 'styled-components'

export const Filters = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: 6px;
    padding: 20px;
`

export const Wrapper = styled.div`
    padding: 0 20px 20px;
`
